module.exports = __webpack_public_path__ + "5c114213/img/arrow-share-icon.00a12c29.svg";